import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { ApplicationUtilsService, InputGewijzigdService } from '@util-services';
import { EcertBaseBlockComponent } from '@building-blocks/ecertnl-base-block/ecertnl-base-block.component';
import { isEmptyValue, isEmptyString } from '@helpers';

@Component({
  selector: 'ecert-input',
  templateUrl: './ecertnl-input.component.html',
  styleUrls: ['./ecertnl-input.component.css'],
  standalone: false,
})
export class EcertInputComponent extends EcertBaseBlockComponent implements OnChanges {
  @Input() id: any = '';
  @Input() autocomplete = '';
  @Input() type = 'text';
  @Input() error: boolean;
  @Input() foutmelding: string;
  @Input() pattern: any;
  @Input() patternFoutmelding: any = null;
  @Input() withoutborder: boolean;
  @Input() clear_button = false;
  @Input() maxlength: number;
  @Input() show_eye = false;
  @Input() errorOverride = false;
  @Input() celcius: false;

  private _previousValue: string;

  foutmeldingRegel2: string;
  foutmeldingRegel3: string;

  constructor(appUtils: ApplicationUtilsService, private inputGewijzigdService: InputGewijzigdService) {
    super(appUtils);
  }

  ngOnChanges({ ref_object, property, vulAutomatisch }: SimpleChanges): void {
    super.ngOnChanges({ ref_object, property, vulAutomatisch });
    if (!isEmptyValue(ref_object) || !isEmptyValue(property)) {
      if (!isEmptyValue(this.ref_object) && !isEmptyString(this.property) && !isEmptyValue(this.ref_object[this.property])) {
        this._previousValue = this.ref_object[this.property];
      }
    }
  }

  leegFoutmelding() {
    this.foutmelding = '';
    this.foutmeldingRegel2 = '';
    this.foutmeldingRegel3 = '';
    this.error = false;
  }

  onBlur(event) {
    event.stopPropagation();
    if (event.target.value === this._previousValue) {
      return;
    }
    this.checkValue(event.target.value);
  }

  checkValue(value) {
    if (value === this._previousValue) {
      return;
    }
    if (!isEmptyValue(this.maxlength) && this.maxlength > 0) {
      this.error = value.length > this.maxlength;
      if (this.error) {
        this.foutmelding = `Invoer is maximaal ${this.maxlength} tekens lang`;
      }
    }
    if (value != null && value.length > 0 && this.pattern != null && !this.pattern.test(value)) {
      this.error = true;
      if (this.pattern != null && !this.pattern.test(value)) {
        if (this.patternFoutmelding != null) {
          this.foutmelding = this.patternFoutmelding.foutmelding;
          this.foutmeldingRegel2 = this.patternFoutmelding.foutmeldingRegel2;
          this.foutmeldingRegel3 = this.patternFoutmelding.foutmeldingRegel3;
        }
        this.error = true;
      }
    } else {
      this.error = false;
    }

    this._previousValue = value;
    this.valueChange.emit({ target: { id: this.id + '-inputfield' }, newValue: value });
    this.inputGewijzigdService.inputGewijzigd(this.id + '-inputfield');
  }

  isPlanVwaEbs() {
    let value = this.appUtils.getSectorParameter('INSP_PLAN_VWA_EBS') as boolean;
    value = value == null ? false : value;
    return value;
  }

  hasErrors() {
    return this.error;
  }

  hasMargin() {
    return true;
  }

  setError(foutmelding) {
    this.foutmelding = foutmelding;
    this.error = true;
  }

  reset() {
    this.valueChange.emit('');
  }

  toggleType() {
    if (this.type == 'text') {
      this.type = 'password';
    } else {
      if (this.type == 'password') {
        this.type = 'text';
      }
    }
  }
}
